import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import InputForm from '../../../../../../../components/form/InputForm';
import CountOfTotal from '../../../../../../../components/CountOfTotal';
import { formRequiredRules } from '../../../../../../../lib/formRules';
import { MAXIMUM_NUMBER_OF_EVENT_TEXT_SECTION_TYPE_TEXT } from '../../../../../../../constants/service/app/eventConstants';
import { REQUIRED_MSG } from '../../../../../../../constants/service/common/formRulesConstants';
import { TextSectionStyle } from './style';

interface TextSectionProps extends FormComponentProps {
  name: string;
  title?: string;
}
const TextSection = (props: TextSectionProps) => {
  const { form, name, title } = props;
  const titleField = form.getFieldValue(`${name}-title`) ?? title;

  return (
    <TextSectionStyle>
      <InputForm
        form={form}
        label={
          <span>
            타이틀
            <CountOfTotal content={titleField} maxCnt={MAXIMUM_NUMBER_OF_EVENT_TEXT_SECTION_TYPE_TEXT} />
          </span>
        }
        rules={[formRequiredRules(true, REQUIRED_MSG)]}
        initialValue={title}
        maxLength={MAXIMUM_NUMBER_OF_EVENT_TEXT_SECTION_TYPE_TEXT}
        subContent={`*타이틀의 글자 수는 최대 ${MAXIMUM_NUMBER_OF_EVENT_TEXT_SECTION_TYPE_TEXT}자 입니다.`}
        name={`${name}-title`}
      />
    </TextSectionStyle>
  );
};

export default TextSection;
